export { Image as default } from './Image';
